import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { useLocation } from 'react-router-dom';

import { fields, initialValues, schema, additionalState, parseData } from './config';

import Sidebar from './Components/Sidebar';


const EditVendorPayment = () => {
  const location = useLocation();

  const state = location.state;

  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);
  const [initValues, setInitValues] = useState(initialValues);

   useEffect(() => {
    if (state?.vendor_id) {
      setFormFields(ofv => {
        return ofv.map(field => {
          if (field.name === "vendor_id") {
            return { ...field, serverOptions: [{ vendor_id: state.vendor_id, full_name: state.vendor_name, mobile_phone: state.mobile_phone, email: state.email }], disabled: true };
          }
          return field;
        });
      });

      setInitValues(oiv => {
        return { ...oiv, vendor_id: state.vendor_id, vendor_name: state.vendor_name };
      });
    }
  }, [state?.vendor_id]);

  return (
    <EditForm title={"Vendor Payment"} initialValues={initValues} fields={formFields} schema={schema} url={"vendor_payments"} additionalState={additionalState} sidebar={<Sidebar />} parseData={parseData}>
      
     </EditForm>
  );
}

export default EditVendorPayment;